import { createTheme, inputBaseClasses, inputClasses, inputLabelClasses, selectClasses } from '@mui/material';

export const vyTheme = createTheme({
  typography: {
    fontFamily: 'Inter, sans-serif',
  },
  palette: {
    primary: {
      main: '#458FFF',
      contrastText: '#FFFFFF',
    },
  },
  components: {
    MuiTextField: {
      variants: [
        {
          props: {
            variant: 'filled',
          },
          style: {
            [`& .${inputBaseClasses.input}`]: {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              background: 'transparent',
            },
            transitionDuration: '0.2s',
            transitionTimingFunction: 'linear',
            '&.Mui-focused': {
              transitionDuration: '0.1s',
              transitionTimingFunction: 'linear',
              background: '#F6F9FA',
              padding: '8px 26px',
              borderRadius: '10px',
              '&.Mui-error': {
                border: '1px solid #FF154D',
              },
            },
            [`& .${inputClasses.multiline}`]: {
              '&.Mui-focused': {
                padding: '12px 26px',
              },
            },
            [`& .${inputLabelClasses.root}`]: {
              fontSize: '18px',
            },
            [`& .${inputLabelClasses.shrink}`]: {
              transform: 'translate(0, -12px) scale(0.8)',
            },
            [`& .${inputLabelClasses.root}.Mui-error`]: {
              color: '#6D6D6D',
            },
            '& label.Mui-focused': {
              color: '#6D6D6D',
            },
            [`& .${selectClasses.icon}`]: {
              marginRight: '10px',
            },
          },
        },
        {
          props: {
            variant: 'outlined',
            SelectProps:{
              MenuProps: {
                PaperProps: {
                  sx: {
                    marginTop: '8px',
                    padding: 0,
                    boxShadow: '0px 8px 16px 0px #0C124514',
                    border: '1px solid #F0F4F6',
                  },
                },
              },
            },
          },
          style: {
          },
        },
      ],
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '5px',
          gap: '8px',
        },
        sizeSmall: {
          padding: '6px 12px',
          fontSize: '0.875rem',
          lineHeight: '20px',
          fontWeight: 500,
        },
        sizeMedium: {
          padding: '10px 16px',
          fontSize: '0.875rem',
          lineHeight: '20px',
          fontWeight: 500,
        },
        sizeLarge: {
          padding: '12px 24px',
          fontSize: '1rem',
          lineHeight: '24px',
          fontWeight: 500,
        },
      },
    },
  },
});